import { c as _c } from "react/compiler-runtime";
import type { LucideIcon } from 'lucide-react';
import { ROTULO_ASSUNTO_INFORMADO } from '@/shared/constants/assuntoInformado';
interface AssuntoDaRespostaProps {
  titulo: string;
  tipo: string;
  participanteLabel: string;
  participante: string;
  referencia: string | null;
  resumo?: string | null;
  icone: LucideIcon;
}
export function AssuntoDaResposta(t0) {
  const $ = _c(30);
  const {
    titulo,
    tipo,
    participanteLabel,
    participante,
    referencia,
    resumo,
    icone: Icone
  } = t0;
  const t1 = `${titulo} ${tipo}`;
  let t2;
  if ($[0] !== Icone) {
    t2 = <span className="text-brand-700 flex h-8 w-8 shrink-0 items-center justify-center rounded-[6px] border border-neutral-200 bg-white" aria-hidden="true"><Icone className="h-4 w-4" /></span>;
    $[0] = Icone;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== titulo) {
    t3 = <p className="text-xs leading-4 font-medium text-neutral-500">{titulo}</p>;
    $[2] = titulo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== tipo) {
    t4 = <strong className="font-semibold">{tipo}</strong>;
    $[4] = tipo;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== participanteLabel) {
    t5 = <span className="text-neutral-500"> · {participanteLabel}: </span>;
    $[6] = participanteLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== participante) {
    t6 = <span className="font-medium">{participante}</span>;
    $[8] = participante;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <p className="text-sm leading-5 break-words text-neutral-800">{t4}{t5}{t6}</p>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== resumo) {
    t8 = resumo && <p className="text-xs leading-4 break-words text-neutral-500">{ROTULO_ASSUNTO_INFORMADO}: {resumo}</p>;
    $[14] = resumo;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== referencia) {
    t9 = referencia && <p className="text-xs break-words text-neutral-500 sm:hidden">Referência: {referencia}</p>;
    $[16] = referencia;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className="min-w-0 flex-1">{t3}{t7}{t8}{t9}</div>;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== referencia) {
    t11 = referencia && <span className="hidden max-w-40 shrink-0 text-right text-xs break-words text-neutral-500 sm:block">{referencia}</span>;
    $[23] = referencia;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t1 || $[26] !== t10 || $[27] !== t11 || $[28] !== t2) {
    t12 = <section aria-label={t1} className="flex min-w-0 items-center gap-2.5 rounded-[16px] border border-neutral-200 bg-neutral-50 px-3 py-2.5">{t2}{t10}{t11}</section>;
    $[25] = t1;
    $[26] = t10;
    $[27] = t11;
    $[28] = t2;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}